import React, { createContext, useContext, useState } from "react";
import { useFormik } from "formik";
import { UserContext } from "./userContext";
import useTailoring from "../hooks/useTailoring";
import { toast } from "react-toastify";
import styled from "styled-components";

const StyledDiv = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  display: grid;
  place-content: center;
  color: white;
  text-align: center;
`;

export const MakeTailoringContext = createContext(null);

const MakeTailoringProvider = ({ children }) => {
  const [isSizeSelected, setSizeSelected] = useState(false);
  const [selectedSize, setSelectedSize] = useState("Select a Size");
  const [productId, setProductId] = useState("");
  const [tailoringQty, setTailoringQty] = useState(1);
  const [makeOrderLoading, setMakeOrderLoading] = useState(false);




  const { handleMakeTailoringOrder } = useTailoring();

  const { userData } = useContext(UserContext);
  const user = userData?.user || {};
  const first_name = user?.first_name;
  const last_name = user?.last_name;
  const email = user?.email;

  const toastOptions = {
    hideProgressBar: true,
    position: "top-center",
    theme: "colored",
  };

  const makeTailoringOrder = (values) => {
    const payload = {
      values,
      id: productId,
      redirect_url: "https://2mseamless-tailoring.vercel.app/success",
    };

    setMakeOrderLoading(true);
    handleMakeTailoringOrder(payload)
      .then((res) => {
        const checkout_url = res?.data?.check_out?.responseBody?.checkoutUrl;
        window.localStorage.setItem("orderId", res?.data?.order_id?.InsertedID);
        window.location.href = checkout_url;
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error(`'${err.response.data.error}'`, toastOptions);
      })
      .finally(() => setMakeOrderLoading(false));
  };

  const tailoringFormik = useFormik({
    initialValues: {
      first_name,
      last_name,
      email,
      size: "",
      delivery: "onsite",
      delivery_address: "",
      pick_up: "hello",
      from_state: "abuja",
      lga: "",
      to_state: "",
      quantity: tailoringQty,
      whatsapp_number: "",
    },
    onSubmit: (values) => {
      const totalValues = {...values, quantity: tailoringQty}
      makeTailoringOrder(totalValues);
      console.log(totalValues);
    },
  });

  const value = {
    tailoringFormik,
    isSizeSelected,
    setSizeSelected,
    selectedSize,
    setSelectedSize,
    setProductId,
    tailoringQty,
    setTailoringQty,
    makeOrderLoading,
  };

  return (
    <MakeTailoringContext.Provider value={value}>
      <>
        {!makeOrderLoading ? (
          children
        ) : (
          <StyledDiv>
            <div class="spinner-border mx-auto" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <span className="d-block">Connecting to a payment gateway...</span>
          </StyledDiv>
        )}
      </>
    </MakeTailoringContext.Provider>
  );
};

export default MakeTailoringProvider;
